import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AttitudesSinglePersona from './AttitudesSinglePersona';
import AttitudesDoubleComparisionPersona from './AttitudesDoubleComparisionPersona';
import AttitudesTripleComparisionPersona from './AttitudesTripleComparisionPersona';
import AttitudeAgreeChoice from './AttitudeAgreeChoice';
import downloadIconDefault from '../../../images/insight360/download-icon_default.png';
import { getOptions, getsortByKeyBasedOnSelectedTab } from '../../../util/Insight360Utils';
import { INGSIGHT_360_ATTITUDE_REPORT_NAME } from '../../../constants';
import indexIconwhite from '../../../images/index-icon_white.png';
import percentIconWhite from '../../../images/percent-icon_white.png';


const Attitudes = ({ download, sourceDataInfo, endId, studyName, sortByKey, pcSortByKey,
  downloadFlag, updateAttitudeAgreeChoice, attitudes, insight360AttitudeAgreeChoice,
  selectedTab, sectionSortingByIndexAndReach }) => (<div>
    {attitudes !== undefined && attitudes.length > 0 && (
      <div className="card main-card">
        <div className="card-header header-card">Attitude
        <span className="section-sort-by-index-reach-btns">
                <button
                  className="section-sort-icon index"
                  title="Index"
                  style={{
                    background: getsortByKeyBasedOnSelectedTab(selectedTab, sortByKey, pcSortByKey, 'index'),
                  }}
                  onClick={() => {
                    sectionSortingByIndexAndReach(INGSIGHT_360_ATTITUDE_REPORT_NAME, 'index');
                  }}
                >
                  <img
                    className="profile-section-sort-icon"
                    src={indexIconwhite}
                  />
                </button>
                <button
                  className="section-sort-icon reach"
                  title="Reach"
                  style={{
                    background: getsortByKeyBasedOnSelectedTab(selectedTab, sortByKey, pcSortByKey, 'pct'),
                  }}
                  onClick={() => {
                    sectionSortingByIndexAndReach(INGSIGHT_360_ATTITUDE_REPORT_NAME, 'pct');
                  }}
                >
                   <img
                     className="profile-section-sort-icon"
                     src={percentIconWhite}
                   />
                </button>
              </span>
        </div>
        <div>
          <div className="row expanded">
            <div className="large-1 medium-1 small-1 columns">&nbsp;</div>
            <div
              className="large-10 medium-10 small-10 columns"
              id="attitudeAgreeChoicePdf"
            >
              {attitudes !== undefined &&
                attitudes.length > 0 && (<AttitudeAgreeChoice
                  insight360AttitudeAgreeChoice={insight360AttitudeAgreeChoice}
                  updateAttitudeAgreeChoice={updateAttitudeAgreeChoice}
                  options={getOptions(attitudes)}
                />
                )}
            </div>
            <div className="large-1 medium-1 small-1 columns">
              <div className="large-12 medium-12 small-12 columns">
                {downloadFlag && (
                  <div className="text-right">
                    <img
                      role="presentation"
                      onClick={() => download(
                        'Attitude',
                        'Attitude',
                        'attitudePersonaGrid',
                        'personaHeader',
                      )
                      }
                      className="export-icon-class"
                      src={downloadIconDefault}
                    />
                  </div>
                )}
                <div>&nbsp;</div>
              </div>
            </div>
          </div>
          <div className="row expanded card-section" id="cardOutlook">
            <div id="attitudePersonaGrid">
              {attitudes !== undefined &&
                attitudes.length === 1 && (<AttitudesSinglePersona
                  studyName={studyName}
                  attitudes={attitudes}
                  insight360AttitudeAgreeChoice={insight360AttitudeAgreeChoice}
                  selectedTab={selectedTab}
                />
                )}
              {attitudes !== undefined &&
                attitudes.length === 2 && (<AttitudesDoubleComparisionPersona
                  attitudes={attitudes}
                  studyName={studyName}
                  insight360AttitudeAgreeChoice={insight360AttitudeAgreeChoice}
                  selectedTab={selectedTab}
                />
                )}
              {attitudes !== undefined &&
                attitudes.length === 3 && (<AttitudesTripleComparisionPersona
                  attitudes={attitudes}
                  studyName={studyName}
                  insight360AttitudeAgreeChoice={insight360AttitudeAgreeChoice}
                  selectedTab={selectedTab}
                />
                )}
            </div>
            {sourceDataInfo('i360-src-data-info text-align-right')}
          </div>
          <div id={endId} />
        </div>
      </div>
    )}
  </div>
  );

Attitudes.propTypes = {
  loginResponse: PropTypes.shape({}),
  attitudes: PropTypes.arrayOf(PropTypes.object),
  updateAttitudeAgreeChoice: PropTypes.func,
  download: PropTypes.func,
  sourceDataInfo: PropTypes.func,
  insight360AttitudeAgreeChoice: PropTypes.string,
  downloadFlag: PropTypes.string,
  endId: PropTypes.string,
  selectedTab: PropTypes.string,
  sortBy: PropTypes.string,
  sectionSortingByIndexAndReach: PropTypes.func,
  sortByKey: PropTypes.string,
  pcSortByKey: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    sortByKey: state.insight360.sortByIndexAndReach.attitudes,
    pcSortByKey: state.insight360.personaCreator.sortByIndexAndReach.attitudes,
  };
}

export default connect(
  mapStateToProps,
  null,
  null,
)(Attitudes);
